import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface SummaryCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
}

/**
 * Displays a card with summary information like dates, counts, or amounts
 */
const SummaryCard: React.FC<SummaryCardProps> = ({ title, value, icon }) => {
  const { t } = useTranslation();
  
  // If title is a translation key, translate it
  const translatedTitle = title.startsWith('transactions.') ? t(title) : title;
  
  return (
    <Card className="h-100 bg-body">
      <Card.Body className="d-flex flex-column justify-content-between p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0 text-body">{translatedTitle}</h6>
          {icon}
        </div>
        <h5 className="fw-bold mb-0 text-body">{value}</h5>
      </Card.Body>
    </Card>
  );
};

export default React.memo(SummaryCard);
